'use client';

export default function NotFound() {
  return (
    <div className='bg-gray-100 flex items-center justify-center h-screen'>
      <div className='text-center'>
        <h1 className='text-6xl font-bold  '>{'404'}</h1>
        <h2 className='mt-4 text-2xl font-semibold text-gray-800'>{'Page Not Found'}</h2>
        <p className='mt-2 text-gray-600'>
          {"Sorry, the page you are looking for doesn't exist or has been moved."}
        </p>
        <a
          href='/'
          className='mt-6 mr-2 inline-block bg-gradient-to-b from-[#1f8ed4] to-[#5ebffd] text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-600'
        >
          {'Go Back Home'}
        </a>
      </div>
    </div>
  );
}
